import script from "./importOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./importOrder.vue?vue&type=script&setup=true&lang=js"

import "./importOrder.vue?vue&type=style&index=0&id=e47d7a54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e47d7a54"]])

export default __exports__